import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumTipoConceptoFlotante } from '../../../oData'
import { EnumCommodity } from '../../enums'
import {
  FloatingConceptsDataTableModel,
  FloatingConceptsModel,
  FloatingConceptsModelPostRequest,
  VirtualBatteryBalanceDetailModel,
  VirtualBatteryBalanceModel
} from './model/floatingConcepts'

export const apiGetFloatingConcepts = async (
  commodity: EnumCommodity,
  tipoConcepto: EnumTipoConceptoFlotante
): Promise<FloatingConceptsDataTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    //`https://localhost:63910/api/FloatingConcepts?commodity=${commodity}&tipoConcepto=${tipoConcepto}`
    `${apiSuffixUrl}/api/FloatingConcepts?commodity=${commodity}&tipoConcepto=${tipoConcepto}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetBalanceActionsFloatingConcepts = async (): Promise<
  FloatingConceptsDataTableModel[]
> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/BalanceActions`
    `${apiSuffixUrl}/api/FloatingConcepts/BalanceActions`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetRightsFloatingConcepts = async (): Promise<FloatingConceptsDataTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/Rights`
    `${apiSuffixUrl}/api/FloatingConcepts/Rights`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostFloatingConcept = async (request: FloatingConceptsModelPostRequest) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/FloatingConcepts`,
    `${apiSuffixUrl}/api/FloatingConcepts`,
    request
  ).then(response => response.data)
}

export const apiPatchFloatingConcept = async (
  request: Partial<FloatingConceptsModelPostRequest>
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/FloatingConcepts`,
    `${apiSuffixUrl}/api/FloatingConcepts`,
    request
  ).then(response => response.data)
}

export const apiDeleteFloatingConcept = async floatingConceptId => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/FloatingConcepts(${floatingConceptId})`
    `${apiSuffixUrl}/api/FloatingConcepts(${floatingConceptId})`
  ).then(response => response.data)
}

export const apiDeleteFloatingConceptsMassive = async (floatingConceptIds: number[]) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/FloatingConcepts/DeleteMassive`,
    floatingConceptIds
  ).then(response => response.data)
}

export const apiGetFloatingConceptsByContractID = async (
  contractId: number,
  commodity: EnumCommodity,
  tipoConcepto: EnumTipoConceptoFlotante,
  startDate?: string,
  endDate?: string
): Promise<FloatingConceptsDataTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    //`https://localhost:63910/api/FloatingConcepts/GetFloatingConceptsByContractID`,
    `${apiSuffixUrl}/api/FloatingConcepts/GetFloatingConceptsByContractID`,
    {
      params: {
        contractID: contractId,
        startDate: startDate,
        endDate: endDate,
        commodity: commodity,
        tipoConcepto: tipoConcepto
      }
    }
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetRightsFloatingConceptsByContractID = async (
  contractId: number,
  startDate?: string,
  endDate?: string
): Promise<FloatingConceptsDataTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/GetRightsFloatingConceptsByContractID`,
    `${apiSuffixUrl}/api/FloatingConcepts/GetRightsFloatingConceptsByContractID`,
    {
      params: {
        contractID: contractId,
        startDate: startDate,
        endDate: endDate
      }
    }
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetFloatingConceptsBySettlementGroupID = async (
  settlementGroupID: number,
  startDate?: string,
  endDate?: string
): Promise<FloatingConceptsDataTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/GetFloatingConceptsBySettlementGroupID`,
    `${apiSuffixUrl}/api/FloatingConcepts/GetFloatingConceptsBySettlementGroupID`,
    {
      params: {
        settlementGroupID: settlementGroupID,
        startDate: startDate,
        endDate: endDate
      }
    }
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetVirtualBatteryBalance = async (): Promise<VirtualBatteryBalanceModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/VirtualBatteryBalance`
    `${apiSuffixUrl}/api/FloatingConcepts/VirtualBatteryBalance`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetVirtualBatteryBalanceDetail = async (
  contractID: number,
  settlementGroupID: number
): Promise<VirtualBatteryBalanceDetailModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  let paramsUrl: string = ''

  if (contractID) {
    paramsUrl = `?contractID=${contractID}`
  } else if (settlementGroupID) {
    paramsUrl = `?settlementGroupID=${settlementGroupID}`
  }

  return await AxiosInstance.get(
    // `https://localhost:59923/api/FloatingConcepts/VirtualBatteryBalanceDetail?contractID=${contractID ?? null}&settlementGroupID=${settlementGroupID ?? null}`
    `${apiSuffixUrl}/api/FloatingConcepts/VirtualBatteryBalanceDetail${paramsUrl}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
